export default __webpack_public_path__ + "static/media/windows.76018483.svg";